import { combineReducers, configureStore } from "@reduxjs/toolkit";


// import RTK Query
import { dashboardApi } from "./Data/services/dashboardApi";
import { userAuthApi } from "./Data/services/userAuthApi";
import { batchesApi } from "./Data/services/batchesApi";
import { classesApi } from "./Data/services/classesApi";


// import feature
import { persistStore } from "redux-persist";
import persistReducer from "redux-persist/es/persistReducer";
import storage from "redux-persist/lib/storage";
import authReducer from "./Data/features/authSlice";
import dashboardSlice from "./Data/features/dashboardSlice";
import classesSlice from "./Data/features/classesSlice";
import batchSlice from "./Data/features/batchSlice";

// import Middleware
import sessionMiddleware from "./Data/middleware/sessionMiddleware"
import { trainingApi } from "./Data/services/trainingApi";

const rootReducer = combineReducers({
  // Add the generated reducer as a specific top-level slice
  //* RTK Query API
  [userAuthApi.reducerPath]: userAuthApi.reducer,
  [dashboardApi.reducerPath]: dashboardApi.reducer,
  [batchesApi.reducerPath]: batchesApi.reducer,
  [classesApi.reducerPath]: classesApi.reducer,
  [trainingApi.reducerPath]: trainingApi.reducer,

  //* Local storage Redux
  auth: authReducer,
  dashboard: dashboardSlice,
  batch: batchSlice,
  classes: classesSlice
});

const rootMiddleware = (getDefaultMiddleware) =>
  getDefaultMiddleware().concat([
    userAuthApi.middleware,
    dashboardApi.middleware,
    batchesApi.middleware,
    classesApi.middleware,
    trainingApi.middleware,
    sessionMiddleware, // for session check each api response
  ]);

export const persistConfig = {
  key: "root",
  storage,
  blacklist: [], // Reducer keys to omit from persisting
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  // load from local storage
  // preloadedState: loadFromLocalStorage(), //todo:

  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  //todo:
  middleware: rootMiddleware,
});

export const persistor = persistStore(store);


